import React from "react";

const NavSVG = ({ icon, state }) => {
  switch (icon) {
    case "home":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask0"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M5,22 C3.34314575,22 2,20.6568542 2,19 L2,5 C2,3.34314575 3.34314575,2 5,2 L19,2 C20.6568542,2 22,3.34314575 22,5 L22,19 C22,20.6568542 20.6568542,22 19,22 L5,22 Z M8,10 L4,10 L4,19 C4,19.5522847 4.44771525,20 5,20 L8,20 L8,10 Z M20,10 L10,10 L10,20 L19,20 C19.5522847,20 20,19.5522847 20,19 L20,10 Z M19,4 L5,4 C4.44771525,4 4,4.44771525 4,5 L4,8 L20,8 L20,5 C20,4.44771525 19.5522847,4 19,4 Z"
              id="path-1"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask0)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask0)">
              <rect width="25" height="25" fill="#333333" />
            </g>
          )}
        </svg>
      );
    case "survey":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask1"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M15,1 C16.1045695,1 17,1.8954305 17,3 L18,3 C19.6568542,3 21,4.34314575 21,6 L21,6 L21,20 C21,21.6568542 19.6568542,23 18,23 L18,23 L6,23 C4.34314575,23 3,21.6568542 3,20 L3,20 L3,6 C3,4.34314575 4.34314575,3 6,3 L6,3 L7,3 C7,1.8954305 7.8954305,1 9,1 L15,1 Z M7,5 L6,5 C5.44771525,5 5,5.44771525 5,6 L5,6 L5,20 C5,20.5522847 5.44771525,21 6,21 L6,21 L18,21 C18.5522847,21 19,20.5522847 19,20 L19,20 L19,6 C19,5.44771525 18.5522847,5 18,5 L18,5 L17,5 C17,6.1045695 16.1045695,7 15,7 L9,7 C7.8954305,7 7,6.1045695 7,5 Z M15,3 L9,3 L9,5 L15,5 L15,3 Z"
              id="path-2"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask1)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask1)">
              <rect width="25" height="25" fill="#333333" />
            </g>
          )}
        </svg>
      );
    case "results":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask2"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M7.60102304,1.91346727 C8.10721008,1.69257563 8.69662382,1.92385326 8.91751546,2.43004031 C9.1384071,2.93622735 8.90712947,3.52564109 8.40094242,3.74653273 C4.69417789,5.36410334 2.52163066,9.25558941 3.08985078,13.2598077 C3.65807091,17.2640259 6.82749183,20.397458 10.8379378,20.9199149 C14.8483837,21.4423718 18.7148067,19.2255274 20.2899424,15.5005327 C20.5050393,14.9918562 21.0917735,14.7538629 21.60045,14.9689597 C22.1091265,15.1840565 22.3471199,15.7707908 22.132023,16.2794673 C20.2068571,20.8322385 15.4812291,23.541715 10.5795729,22.9031566 C5.67791675,22.2645981 1.80418007,18.4348479 1.10968881,13.5408033 C0.415197546,8.64675878 3.07053305,3.89049802 7.60102304,1.91346727 Z M12.0009827,1 C14.9183641,1 17.7162572,2.15892524 19.7791573,4.22182541 C21.8420575,6.28472557 23.0009827,9.08261861 23.0009827,12 C23.0009827,12.5522847 22.5532675,13 22.0009827,13 L12.0009827,13 C11.448698,13 11.0009827,12.5522847 11.0009827,12 L11.0009827,2 C11.0009827,1.44771525 11.448698,1 12.0009827,1 Z M13.0009827,3.05569676 L13.0009827,11 L20.945286,11 C20.7196104,8.98098115 19.815371,7.0864662 18.3649438,5.63603897 C16.9145165,4.18561174 15.0200016,3.28137235 13.0009827,3.05569676 Z"
              id="path-3"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask2)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask2)">
              <rect width="25" height="25" fill="#333333" />
            </g>
          )}
        </svg>
      );
    case "reports":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask3"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M11,4 L11,20 L13,20 L13,4 L11,4 Z M14,2 C14.5522847,2 15,2.44771525 15,3 L15,21 C15,21.5522847 14.5522847,22 14,22 L10,22 C9.44771525,22 9,21.5522847 9,21 L9,3 C9,2.44771525 9.44771525,2 10,2 L14,2 Z M22,7 C22.5522847,7 23,7.44771525 23,8 L23,21 C23,21.5522847 22.5522847,22 22,22 L18,22 C17.4477153,22 17,21.5522847 17,21 L17,8 C17,7.44771525 17.4477153,7 18,7 L22,7 Z M6,12 C6.55228475,12 7,12.4477153 7,13 L7,21 C7,21.5522847 6.55228475,22 6,22 L2,22 C1.44771525,22 1,21.5522847 1,21 L1,13 C1,12.4477153 1.44771525,12 2,12 L6,12 Z M21,9 L19,9 L19,20 L21,20 L21,9 Z M5,14 L3,14 L3,20 L5,20 L5,14 Z"
              id="path-4"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask3)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask3)">
              <rect width="25" height="25" fill="#333333" />
            </g>
          )}
        </svg>
      );
    case "profile":
      return (
        <svg
          width="24"
          height="24"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask4"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M16,14 C18.7614237,14 21,16.2385763 21,19 L21,19 L21,21 C21,21.5522847 20.5522847,22 20,22 C19.4477153,22 19,21.5522847 19,21 L19,21 L19,19 C19,17.3431458 17.6568542,16 16,16 L16,16 L8,16 C6.34314575,16 5,17.3431458 5,19 L5,19 L5,21 C5,21.5522847 4.55228475,22 4,22 C3.44771525,22 3,21.5522847 3,21 L3,21 L3,19 C3,16.2385763 5.23857625,14 8,14 L8,14 Z M12,2 C14.7614237,2 17,4.23857625 17,7 C17,9.76142375 14.7614237,12 12,12 C9.23857625,12 7,9.76142375 7,7 C7,4.23857625 9.23857625,2 12,2 Z M12,4 C10.3431458,4 9,5.34314575 9,7 C9,8.65685425 10.3431458,10 12,10 C13.6568542,10 15,8.65685425 15,7 C15,5.34314575 13.6568542,4 12,4 Z"
              id="path-5"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask4)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask4)">
              <rect width="25" height="25" fill="#333333" />
            </g>
          )}
        </svg>
      );
    case "visible":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask4"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M12,3 C15.3798024,3 18.3386923,4.63249094 20.8545372,7.31605887 C21.7188737,8.23801779 22.4694995,9.22244509 23.1056644,10.2074746 C23.4900327,10.8026256 23.7538591,11.2716502 23.8944272,11.5527864 C24.0351909,11.8343139 24.0351909,12.1656861 23.8944272,12.4472136 C23.7538591,12.7283498 23.4900327,13.1973744 23.1056644,13.7925254 C22.4694995,14.7775549 21.7188737,15.7619822 20.8545372,16.6839411 C18.3386923,19.3675091 15.3798024,21 12,21 C8.62019756,21 5.66130774,19.3675091 3.1454628,16.6839411 C2.28112631,15.7619822 1.5305005,14.7775549 0.894335622,13.7925254 C0.50996726,13.1973744 0.246140906,12.7283498 0.105572809,12.4472136 C-0.0351909363,12.1656861 -0.0351909363,11.8343139 0.105572809,11.5527864 C0.246140906,11.2716502 0.50996726,10.8026256 0.894335622,10.2074746 C1.5305005,9.22244509 2.28112631,8.23801779 3.1454628,7.31605887 C5.66130774,4.63249094 8.62019756,3 12,3 Z M12,5 C9.25480244,5 6.77619226,6.36750906 4.6045372,8.68394113 C3.82824869,9.51198221 3.149187,10.4025549 2.57441438,11.2925254 C2.41127724,11.5451249 2.26658862,11.7823697 2.14071218,12 C2.26658862,12.2176303 2.41127724,12.4548751 2.57441438,12.7074746 C3.149187,13.5974451 3.82824869,14.4880178 4.6045372,15.3160589 C6.77619226,17.6324909 9.25480244,19 12,19 C14.7451976,19 17.2238077,17.6324909 19.3954628,15.3160589 C20.1717513,14.4880178 20.850813,13.5974451 21.4255856,12.7074746 C21.5887228,12.4548751 21.7334114,12.2176303 21.8592878,12 C21.7334114,11.7823697 21.5887228,11.5451249 21.4255856,11.2925254 C20.850813,10.4025549 20.1717513,9.51198221 19.3954628,8.68394113 C17.2238077,6.36750906 14.7451976,5 12,5 Z M12,8 C14.209139,8 16,9.790861 16,12 C16,14.209139 14.209139,16 12,16 C9.790861,16 8,14.209139 8,12 C8,9.790861 9.790861,8 12,8 Z M12,10 C10.8954305,10 10,10.8954305 10,12 C10,13.1045695 10.8954305,14 12,14 C13.1045695,14 14,13.1045695 14,12 C14,10.8954305 13.1045695,10 12,10 Z"
              id="path-5"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask4)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask4)">
              <rect width="25" height="25" fill="#aaa" />
            </g>
          )}
        </svg>
      );
    case "visible-off":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask4"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M0.292893219,0.292893219 C0.683417511,-0.0976310729 1.31658249,-0.0976310729 1.70710678,0.292893219 L1.70710678,0.292893219 L23.7071068,22.2928932 C24.0976311,22.6834175 24.0976311,23.3165825 23.7071068,23.7071068 C23.3165825,24.0976311 22.6834175,24.0976311 22.2928932,23.7071068 L22.2928932,23.7071068 L17.8253488,19.2407516 C16.0954292,20.3537292 14.0824627,20.9660698 11.9999999,21 C8.62019756,21 5.66130774,19.3675091 3.1454628,16.6839411 C2.28112631,15.7619822 1.5305005,14.7775549 0.894335622,13.7925254 C0.50996726,13.1973744 0.246140906,12.7283498 0.105572809,12.4472136 C-0.0397387988,12.1565904 -0.034789519,11.8134847 0.11884433,11.5271737 C1.25026898,9.41865882 2.75946605,7.5399487 4.56806449,5.98304415 L0.292893219,1.70710678 C-0.0976310729,1.31658249 -0.0976310729,0.683417511 0.292893219,0.292893219 Z M5.98657721,7.40175097 C4.45001132,8.70173013 3.14922004,10.258376 2.14255627,12.0031874 C2.26800116,12.2199461 2.41207332,12.4561078 2.57441438,12.7074746 C3.149187,13.5974451 3.82824869,14.4880178 4.6045372,15.3160589 C6.77619226,17.6324909 9.25480244,19 11.9836527,19.0001336 C13.531663,18.9748244 15.0407185,18.5539338 16.3705689,17.7861007 L14.0489794,15.4645626 C13.1338506,16.0378644 12.010311,16.2249577 10.9354035,15.9504452 C9.51815892,15.5885058 8.41149424,14.4818411 8.04955483,13.0645965 C7.77504233,11.989689 7.96213562,10.8661494 8.53543743,9.95102065 Z M12,2.99997214 C15.3798024,2.99997214 18.3386923,4.63249094 20.8545372,7.31605887 C21.7188737,8.23801779 22.4694995,9.22244509 23.1056644,10.2074746 C23.4900327,10.8026256 23.7538591,11.2716502 23.8944272,11.5527864 C24.0394855,11.842903 24.0348204,12.1853547 23.881913,12.4714122 C23.2420806,13.6684038 22.4790254,14.7953232 21.6051562,15.8338447 C21.2495706,16.2564288 20.6187395,16.3107418 20.1961553,15.9551562 C19.7735712,15.5995706 19.7192582,14.9687395 20.0748438,14.5461553 C20.7439122,13.7510227 21.3405972,12.8981486 21.8579836,11.9977456 C21.7324123,11.7807317 21.5881596,11.5442529 21.4255856,11.2925254 C20.850813,10.4025549 20.1717513,9.51198221 19.3954628,8.68394113 C17.2238077,6.36750906 14.7451976,5 11.9976501,4.99999724 C11.368229,4.99851813 10.7407705,5.07022768 10.1279132,5.21368145 C9.5901638,5.33955444 9.05219155,5.00566263 8.92631855,4.46791322 C8.80044556,3.9301638 9.13433737,3.39219155 9.67208678,3.26631855 C10.4358941,3.08753134 11.2178991,2.99815934 12,2.99997214 Z M10.0278716,11.4421582 C9.90853162,11.8000966 9.8906295,12.1909443 9.98736084,12.5697148 C10.1683305,13.2783371 10.7216629,13.8316695 11.4302852,14.0126392 C11.8090557,14.1093705 12.1999034,14.0914684 12.5578418,13.9721284 Z"
              id="path-5"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask4)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask4)">
              <rect width="25" height="25" fill="#aaa" />
            </g>
          )}
        </svg>
      );
    case "kanban":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask5"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M4,3 C3.44771525,3 3,3.44771525 3,4 L3,8 C3,8.55228475 3.44771525,9 4,9 L20,9 C20.5522847,9 21,8.55228475 21,8 L21,4 C21,3.44771525 20.5522847,3 20,3 L4,3 Z M20,13 C21.6568542,13 23,14.3431458 23,16 L23,20 C23,21.6568542 21.6568542,23 20,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,16 C1,14.3431458 2.34314575,13 4,13 L20,13 Z M20,15 L4,15 C3.44771525,15 3,15.4477153 3,16 L3,20 C3,20.5522847 3.44771525,21 4,21 L20,21 C20.5522847,21 21,20.5522847 21,20 L21,16 C21,15.4477153 20.5522847,15 20,15 Z M20,1 C21.6568542,1 23,2.34314575 23,4 L23,8 C23,9.65685425 21.6568542,11 20,11 L4,11 C2.34314575,11 1,9.65685425 1,8 L1,4 C1,2.34314575 2.34314575,1 4,1 L20,1 Z"
              id="path-5"
              fill="#333333"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask5)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask5)">
              <rect width="25" height="25" fill="#333" />
            </g>
          )}
        </svg>
      );
    case "thumbsUp":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask10"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M19.6486763,8.00006412 C20.5288038,7.99009715 21.368906,8.36714393 21.946464,9.03133562 C22.524022,9.69552732 22.7807603,10.5798471 22.6484478,11.451562 L21.2686957,20.4499361 C21.0443874,21.9290503 19.7646258,23.0168476 18.28,23.000193 L7,23.000193 C6.44771525,23.000193 6,22.5522847 6,22 L6,11 C6,10.8600817 6.02936223,10.7217205 6.08618845,10.5938615 L10.0861885,1.59386153 C10.2466898,1.23273352 10.6048113,1 11,1 C13.209139,1 15,2.790861 15,5 L15,8.00001135 L19.6486763,8.00006412 Z M8,21.0001287 L18.2913043,21.0001287 C18.7899477,21.0057011 19.2165349,20.643102 19.2915522,20.148438 L20.6713237,11.1499359 C20.7153517,10.8598635 20.6297723,10.5650903 20.437253,10.3436931 C20.2447337,10.1222958 19.9646996,9.99661356 19.66,10 L14,10 C13.4477153,10 13,9.55228475 13,9 L13,5 C13,4.107435 12.4153102,3.35143161 11.6080478,3.09410694 L8,11.2122145 L8,21.0001287 Z M6,12 L4,12 C3.44771525,12 3,12.4477153 3,13 L3,20 C3,20.5522847 3.44771525,21 4,21 L6,21 L6,12 Z M7,23 L4,23 C2.34314575,23 1,21.6568542 1,20 L1,13 C1,11.3431458 2.34314575,10 4,10 L7,10 C7.55228475,10 8,10.4477153 8,11 L8,22 C8,22.5522847 7.55228475,23 7,23 Z"
              id="path-10"
              fill="#00A099"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask10)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask10)">
              <rect width="25" height="25" fill="#00A099" />
            </g>
          )}
        </svg>
      );
    case "thumbsDown":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask11"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M9,15.9999886 L4.35132373,15.9999359 C3.47119618,16.0099029 2.63109397,15.6328561 2.05353597,14.9686644 C1.47597797,14.3044727 1.2192397,13.4201529 1.35155225,12.548438 L2.73130431,3.5500639 C2.95561258,2.07094973 4.23537419,0.983152355 5.72,0.999806967 L17,0.999806967 C17.5522847,0.999806967 18,1.44771525 18,2 L18,13 C18,13.1399183 17.9706378,13.2782795 17.9138115,13.4061385 L13.9138115,22.4061385 C13.7533102,22.7672665 13.3951887,23 13,23 C10.790861,23 9,21.209139 9,19 L9,15.9999886 Z M5.70869569,2.99987127 C5.21005232,2.99429892 4.78346511,3.35689805 4.70844775,3.85156199 L3.32867627,12.8500641 C3.28464826,13.1401365 3.37022768,13.4349097 3.56274701,13.6563069 C3.75526634,13.8777042 4.03530042,14.0033864 4.34,14 L10,14 C10.5522847,14 11,14.4477153 11,15 L11,19 C11,19.892565 11.5846898,20.6485684 12.3919522,20.9058931 L16,12.7877855 L16,2.99987127 L5.70869569,2.99987127 Z M18,12.0000582 L19.6876825,12.0001563 C20.3326214,12.0115622 20.8866873,11.5524785 21,10.9232314 L21,4.07677109 C20.8866736,3.44752281 20.3321056,2.98844231 19.67,3 L18,3 L18,12.0000582 Z M17,1 L19.6523175,1.00015635 C21.3309455,0.970469428 22.7659324,2.20221784 22.9909755,3.86595721 L23,4 L23,11 L22.9909755,11.1340428 C22.7659324,12.7977822 21.3309455,14.0295306 19.67,14 L17,14 C16.4477153,14 16,13.5522847 16,13 L16,2 C16,1.44771525 16.4477153,1 17,1 Z"
              id="path-11"
              fill="#AC2845"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask11)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask11)">
              <rect width="25" height="25" fill="#AC2845" />
            </g>
          )}
        </svg>
      );
    case "Check":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask12"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M4.70710678,12.2928932 C4.31658249,11.9023689 3.68341751,11.9023689 3.29289322,12.2928932 C2.90236893,12.6834175 2.90236893,13.3165825 3.29289322,13.7071068 L8.29289322,18.7071068 C8.68341751,19.0976311 9.31658249,19.0976311 9.70710678,18.7071068 L20.7071068,7.70710678 C21.0976311,7.31658249 21.0976311,6.68341751 20.7071068,6.29289322 C20.3165825,5.90236893 19.6834175,5.90236893 19.2928932,6.29289322 L9,16.5857864 L4.70710678,12.2928932 Z"
              id="path-12"
              fill="#00A099"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask12)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask12)">
              <rect width="25" height="25" fill="#00A099" />
            </g>
          )}
        </svg>
      );
    case "Cross":
      return (
        <svg
          width="25"
          height="25"
          viewBox="0 0 25 25"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <mask
            id="mask13"
            mask-type="alpha"
            maskUnits="userSpaceOnUse"
            x="0"
            y="1"
            width="25"
            height="23"
          >
            <path
              d="M5.29289322,5.29289322 C5.68341751,4.90236893 6.31658249,4.90236893 6.70710678,5.29289322 L6.70710678,5.29289322 L12,10.585 L17.2928932,5.29289322 C17.6533772,4.93240926 18.2206082,4.90467972 18.6128994,5.20970461 L18.7071068,5.29289322 C19.0976311,5.68341751 19.0976311,6.31658249 18.7071068,6.70710678 L18.7071068,6.70710678 L13.415,12 L18.7071068,17.2928932 C19.0675907,17.6533772 19.0953203,18.2206082 18.7902954,18.6128994 L18.7071068,18.7071068 C18.3165825,19.0976311 17.6834175,19.0976311 17.2928932,18.7071068 L17.2928932,18.7071068 L12,13.415 L6.70710678,18.7071068 C6.34662282,19.0675907 5.77939176,19.0953203 5.38710056,18.7902954 L5.29289322,18.7071068 C4.90236893,18.3165825 4.90236893,17.6834175 5.29289322,17.2928932 L5.29289322,17.2928932 L10.585,12 L5.29289322,6.70710678 C4.93240926,6.34662282 4.90467972,5.77939176 5.20970461,5.38710056 Z"
              id="path-13"
              fill="#AC2845"
            ></path>
          </mask>
          {state === "active" ? (
            <>
              <g mask="url(#mask13)">
                <rect width="25" height="25" fill="#03A6CC" />
              </g>
            </>
          ) : (
            <g mask="url(#mask13)">
              <rect width="25" height="25" fill="#AC2845" />
            </g>
          )}
        </svg>
      );
    default:
      break;
  }
};

export default NavSVG;
